import { Text, Html, ContactShadows, PresentationControls, Float, Environment, useGLTF, OrbitControls } from '@react-three/drei'

export default function Experience() {
    const computer = useGLTF('https://threejs-journey.com/resources/models/macbook_model.gltf')

    return <>

        <color args={ [ '#272626' ] } attach="background" />
        
                <Environment preset="city" />
                
                <PresentationControls
                    global
                    rotation={ [ 0.13, 0.1, 0 ] }
                    polar={ [ - 0.4, 0.2 ] }
                    //azimuth={ [ - 1, 0.75 ] }
                    damping={ 0.1 }
                    snap
                >
                    <Float rotationIntensity={ 0.4 } >  
                        <rectAreaLight
                            width={ 2.5 }
                            height={ 1.65 }
                            intensity={ 65 }
                            color={ '#fafafa' }
                            rotation={ [ - 0.1, Math.PI, 0 ] }
                            position={ [ 0, 0.55, - 1.15 ] }
                        />
        
                        <primitive
                            object={ computer.scene }
                            position-y={ - 1.2 }
                            // rotation-x={ 0.13 }
                        >
                            <Html
                                transform
                                occlude
                                wrapperClass="htmlScreen"
                                distanceFactor={ 1.17 }
                                position={ [ 0, 1.56, - 1.4 ] }
                                rotation-x={ - 0.256 }
                            >
                                <iframe src="https://complex-analysis.com/" />
                            </Html>
                        </primitive>
        
                        <Text
                            font="./LM-bold.woff"
                            fontSize={ 0.55 }
                            position={ [ 2, 0.65, 0.15 ] }
                            rotation-y={ - 1.25 }
                            maxWidth={ 2 }
                        >
                            Complex Analysis
                        </Text>
                    </Float>
                </PresentationControls>
        
                <ContactShadows
                    position-y={ - 1.4 }
                    opacity={ 0.4 }
                    scale={ 5 }
                    blur={ 2.4 }
                />



    </>
}